import AppThemeProvider from './ThemeProvider';

const Provider = ({ children }) => {
  return <AppThemeProvider>{children}</AppThemeProvider>;
};

export default Provider;
